import React from 'react';
import { Row, Col, Image, Space, Typography, Collapse, Grid } from 'antd';
import Clay from '../../assets/img/clay-banks-e6pK_snssSY-unsplash.png';

const { useBreakpoint } = Grid;
const { Text } = Typography;
const { Panel } = Collapse;

function Theme() {
  const { xs } = useBreakpoint()
  return (
    <React.Fragment>
      {
        xs ?
          <Row className='content-body' justify="space-around" align="middle" gutter={[0,32]} style={{ backgroundColor: '#fff' }}>
            <Col span={24}>
              <Image
                width={'100%'}
                src={Clay}
                preview={false}
                style={{ objectFit: 'cover' }}
              />
            </Col>
            <Col span={24}>
              <Space direction="vertical" size={16}>
                <Space direction="vertical">
                  <Text style={{ fontSize: 20, fontWeight: 'bold' }}>Theme and Topic</Text>
                </Space>
                <Collapse bordered={false} defaultActiveKey={['2']} gutter={128} style={{ backgroundColor: '#fff' }}>
                  <Panel header={<Text style={{ fontSize: 18, fontWeight: 'bold' }}>Theme</Text>} key="1">
                    <Text style={{ fontSize: 16 }}>Health, Business, and Work in a Post Pandemic World.</Text>
                  </Panel>
                  <Panel header={<Text style={{ fontSize: 18, fontWeight: 'bold' }}>Topic</Text>} key="2">
                    <ul style={{ marginLeft: -24 }}>
                      <li><Text style={{ fontSize: 16 }}>Disaster Management: Crisis Management Before the Crisis Happen</Text></li>
                      <li><Text style={{ fontSize: 16 }}>Climate Change and Occupational Hazard in a Post Pandemic World</Text></li>
                      <li><Text style={{ fontSize: 16 }}>Health Industry: Sustainability, Business, and Financial Strategy</Text></li>
                      <li><Text style={{ fontSize: 16 }}>Social Work Intervention, Community Development, and Disability Empowerment</Text></li>
                      <li><Text style={{ fontSize: 16 }}>Positive Psychology, Wellbeing, and Mental Health</Text></li>
                      <li><Text style={{ fontSize: 16 }}>Digital Technology, Transformation and Strategy</Text></li>
                      <li><Text style={{ fontSize: 16 }}>Nutrition Strategies to Improve Community Food Security and Health in a Post Pandemic World</Text></li>
                      <li><Text style={{ fontSize: 16 }}>Occupational Health and Safety in a Post Pandemic World</Text></li>
                      <li><Text style={{ fontSize: 16 }}>Nursing, Midwifery, Maternal & Child Health</Text></li>
                      <li><Text style={{ fontSize: 16 }}>Family planning and Reproductive Health in a post pandemic world</Text></li>
                      <li><Text style={{ fontSize: 16 }}>Pharmaceutical Sciences and Clinical Pharmacy</Text></li>
                    </ul>
                  </Panel>
                </Collapse>
              </Space>
            </Col>
          </Row>
        :
          <Row className='content-body' justify="space-around" align="middle" gutter={64} style={{ backgroundColor: '#fff' }}>
            <Col span={12}>
              <Image
                width={'100%'}
                src={Clay}
                preview={false}
                style={{ objectFit: 'cover' }}
              />
            </Col>
            <Col span={12}>
              <Space direction="vertical" size={32}>
                <Space direction="vertical" size={-8}>
                  <Text style={{ fontSize: 28, fontWeight: 'bold' }}>Theme and Topic</Text>
                </Space>
                <Collapse bordered={false} defaultActiveKey={['2']} gutter={128} style={{ backgroundColor: '#fff' }}>
                  <Panel header={<Text style={{ fontSize: 18, fontWeight: 'bold' }}>Theme</Text>} key="1">
                    <Text style={{ fontSize: 16 }}>Health, Business, and Work in a Post Pandemic World.</Text>
                  </Panel>
                  <Panel header={<Text style={{ fontSize: 18, fontWeight: 'bold' }}>Topic</Text>} key="2">
                    <ul style={{ marginLeft: -24 }}>
                      <li><Text style={{ fontSize: 16 }}>Disaster Management: Crisis Management Before the Crisis Happen</Text></li>
                      <li><Text style={{ fontSize: 16 }}>Climate Change and Occupational Hazard in a Post Pandemic World</Text></li>
                      <li><Text style={{ fontSize: 16 }}>Health Industry: Sustainability, Business, and Financial Strategy</Text></li>
                      <li><Text style={{ fontSize: 16 }}>Social Work Intervention, Community Development, and Disability Empowerment</Text></li>
                      <li><Text style={{ fontSize: 16 }}>Positive Psychology, Wellbeing, and Mental Health</Text></li>
                      <li><Text style={{ fontSize: 16 }}>Digital Technology, Transformation and Strategy</Text></li>
                      <li><Text style={{ fontSize: 16 }}>Nutrition Strategies to Improve Community Food Security and Health in a Post Pandemic World</Text></li>
                      <li><Text style={{ fontSize: 16 }}>Occupational Health and Safety in a Post Pandemic World</Text></li>
                      <li><Text style={{ fontSize: 16 }}>Nursing, Midwifery, Maternal & Child Health</Text></li>
                      <li><Text style={{ fontSize: 16 }}>Family planning and Reproductive Health in a post pandemic world</Text></li>
                      <li><Text style={{ fontSize: 16 }}>Pharmaceutical Sciences and Clinical Pharmacy</Text></li>
                    </ul>
                  </Panel>
                </Collapse>
              </Space>
            </Col>
          </Row>
      }
    </React.Fragment>
  )
}

export default Theme